// extracted by mini-css-extract-plugin
module.exports = {"name__wrapper":"widget-name_name__wrapper__2k_Go","name":"widget-name_name__3OkCR"};